import ScalebarControl from './scalebar-control';
import app from '../../public-api';

app.plugins.register({
  name: 'us:scalebar',

  extends: 'viewport',

  dependencies: [
    'us:user-config',
    'us:settings:visibility-panel',
    [ 'us:unit-converter', { required: false } ]
  ],

  factory (uScope, viewport, userConfig, visibilityPanel, unitConverter) {
    const scalebar = new ScalebarControl(uScope, viewport, userConfig, visibilityPanel, unitConverter);

    // Polluting the viewport is a temp hack till I find a better way of handling however this is used.
    viewport.scaleBar = scalebar;

    return scalebar;
  }
});
